import { createClient, type PostgrestSingleResponse } from '@supabase/supabase-js';
import type { Database } from '@farmos/shared/db';
import { env } from './env';

export const supabase = createClient<Database>(env.supabaseUrl, env.supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

export type Tables<T extends keyof Database['public']['Tables']> =
  Database['public']['Tables'][T]['Row'];
export type Views<T extends keyof Database['public']['Views']> =
  Database['public']['Views'][T]['Row'];

/** Throw Supabase errors so TanStack Query can surface them. */
type SupaError = { message: string; code?: string };

/**
 * Throw Supabase errors so TanStack Query can surface them. Typed on the success branch,
 * so `.maybeSingle()` results stay nullable and everything else doesn't.
 */
export function unwrap<T>(res: PostgrestSingleResponse<T>): T;
export function unwrap<T>(res: { data: T; error: SupaError | null }): T;
export function unwrap<T>(res: { data: T; error: SupaError | null }): T {
  if (res.error) throw Object.assign(new Error(res.error.message), { code: res.error.code });
  return res.data;
}
